"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopHeader = TopHeader;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var logout_1 = require("../features/thunks/logout");
var hooks_1 = require("../store/hooks");
var notification_bell_1 = require("./notification-bell");
var tariff_reminder_popup_1 = require("./tariff-reminder-popup");
function TopHeader() {
    var _this = this;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var isNavbarCollapsed = (0, hooks_1.useAppSelector)(function (state) { return state.common; }).isNavbarCollapsed;
    var name = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }).name;
    var _a = (0, react_3.useState)(false), isFullscreen = _a[0], setIsFullscreen = _a[1];
    var _b = (0, react_3.useState)("en"), currentLanguage = _b[0], setCurrentLanguage = _b[1];
    var _c = (0, react_3.useState)(false), isSettingsOpen = _c[0], setIsSettingsOpen = _c[1];
    var settingsRef = (0, react_3.useRef)(null);
    (0, react_3.useEffect)(function () {
        function handleClickOutside(event) {
            if (settingsRef.current && !settingsRef.current.contains(event.target)) {
                setIsSettingsOpen(false);
            }
        }
        if (isSettingsOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            return function () {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [isSettingsOpen]);
    var toggleFullscreen = function () {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            setIsFullscreen(true);
        }
        else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
                setIsFullscreen(false);
            }
        }
    };
    var languages = [
        { key: "en", label: "English", flag: "🇺🇸" },
        { key: "es", label: "Español", flag: "🇪🇸" },
        { key: "fr", label: "Français", flag: "🇫🇷" },
        { key: "de", label: "Deutsch", flag: "🇩🇪" },
    ];
    var handleSettingsAction = function (key) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(key === "logout")) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch((0, logout_1.logoutThunk)())];
                case 1:
                    result = _a.sent();
                    if (result.payload === "logout") {
                        navigate("/login");
                    }
                    return [3 /*break*/, 3];
                case 2:
                    if (key === "account-settings") {
                        navigate("/dashboard/account/settings");
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // Get user initials for avatar
    var initials = name
        ? name
            .split(" ")
            .map(function (n) { return n[0]; })
            .join("")
            .toUpperCase()
            .slice(0, 2)
        : "?";
    return ((0, jsx_runtime_1.jsxs)("div", { className: "fixed right-0 top-0 z-40 flex h-16 items-center justify-between border-b border-gray-200/80 bg-white/80 px-6 backdrop-blur-md transition-all duration-300 ".concat(isNavbarCollapsed ? "left-16 md:left-20" : "left-64"), children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsxs)(react_1.Dropdown, { placement: "bottom-end", children: [(0, jsx_runtime_1.jsx)(react_1.DropdownTrigger, { children: (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "light", size: "sm", radius: "full", className: "text-gray-500 hover:text-gray-700", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:translate", className: "text-xl" }) }) }), (0, jsx_runtime_1.jsx)(react_1.DropdownMenu, { "aria-label": "Language selection", onAction: function (key) { return setCurrentLanguage(key); }, selectedKeys: new Set([currentLanguage]), selectionMode: "single", children: languages.map(function (lang) { return ((0, jsx_runtime_1.jsxs)(react_1.DropdownItem, { children: [lang.flag, " ", lang.label] }, lang.key)); }) })] }), (0, jsx_runtime_1.jsx)(notification_bell_1.NotificationBell, {}), (0, jsx_runtime_1.jsx)(tariff_reminder_popup_1.TariffReminderPopup, {}), (0, jsx_runtime_1.jsx)(react_1.Button, { isIconOnly: true, variant: "light", size: "sm", radius: "full", className: "text-gray-500 hover:text-gray-700", onPress: toggleFullscreen, children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: isFullscreen ? "mdi:fullscreen-exit" : "mdi:fullscreen", className: "text-xl" }) }), (0, jsx_runtime_1.jsx)("div", { className: "mx-1 h-8 w-px bg-gray-200" }), (0, jsx_runtime_1.jsxs)("div", { className: "relative flex items-center gap-3", ref: settingsRef, children: [name && (0, jsx_runtime_1.jsx)("span", { className: "hidden text-sm text-gray-600 md:block", children: name }), (0, jsx_runtime_1.jsx)("button", { onClick: function () { return setIsSettingsOpen(!isSettingsOpen); }, className: "flex h-9 w-9 items-center justify-center rounded-full bg-teal-500 text-sm font-semibold text-white transition-all hover:bg-teal-600 hover:shadow-md", children: initials }), isSettingsOpen && ((0, jsx_runtime_1.jsxs)("div", { className: "absolute right-0 top-full z-50 mt-2 w-56 overflow-hidden rounded-xl border border-gray-100 bg-white shadow-xl", children: [(0, jsx_runtime_1.jsxs)("div", { className: "border-b border-gray-100 px-4 py-3", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium text-gray-900", children: name }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-gray-500", children: "Manage your account" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "py-1", children: [(0, jsx_runtime_1.jsxs)("button", { onClick: function () {
                                                    handleSettingsAction("account-settings");
                                                    setIsSettingsOpen(false);
                                                }, className: "flex w-full items-center gap-3 px-4 py-2.5 text-sm text-gray-700 transition-colors hover:bg-gray-50", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:settings-linear", className: "text-lg text-gray-400" }), "Account Settings"] }), (0, jsx_runtime_1.jsxs)("button", { onClick: function () {
                                                    handleSettingsAction("logout");
                                                    setIsSettingsOpen(false);
                                                }, className: "flex w-full items-center gap-3 px-4 py-2.5 text-sm text-red-600 transition-colors hover:bg-red-50", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:logout-2-linear", className: "text-lg" }), "Log Out"] })] })] }))] })] })] }));
}
